import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import styles from './SpecialProjectCarouselLayout.css';

export type SpecialProjectCarouselLayoutProps = {
  carousel: ReactNode;
  builder: ReactNode;
  offersFewed: boolean;
};

export const SpecialProjectCarouselLayout: FC<SpecialProjectCarouselLayoutProps> = ({
  carousel,
  builder,
  offersFewed,
}) => {
  return (
    <div
      className={clsx(styles['container'], offersFewed && `carousel-offers-fewed`)}
      data-testid="SpecialProjectCarouselLayout"
    >
      <div className={styles['builder']}>{builder}</div>
      <div className={styles['carousel']}>{carousel}</div>
    </div>
  );
};
